module.exports = __webpack_public_path__ + "components/flag/static/square/lk-78471b88de894590761ac673b23264fa.svg";